import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GuidUtilities {
    /* Taken from
    https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    */
    getGuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            // eslint-disable-next-line no-bitwise
            const r = (Math.random() * 16) | 0;
            // eslint-disable-next-line no-bitwise
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    isValid(str: string): boolean {
        const validRegex =
            /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return validRegex.test(str);
    }

    getEmpty(): string {
        return '00000000-0000-0000-0000-000000000000';
    }
}
